import type { TourDefinition } from "../types";

export const assetsTour: TourDefinition = {
  id: "assets",
  titleKey: "onboarding.tours.assets.title",
  descriptionKey: "onboarding.tours.assets.description",
  module: "assets",
  estimatedMinutes: 2,
  steps: [
    {
      id: "assets-intro",
      targetSelector: "[data-tour='search-input']",
      titleKey: "onboarding.tours.assets.intro.title",
      descriptionKey: "onboarding.tours.assets.intro.description",
      placement: "bottom",
      navigateTo: "/assets",
      waitForSelector: "[data-tour='search-input']",
    },
    {
      id: "assets-add",
      targetSelector: "[data-tour='create-button']",
      titleKey: "onboarding.tours.assets.add.title",
      descriptionKey: "onboarding.tours.assets.add.description",
      placement: "bottom",
      action: "click",
      actionTarget: "[aria-label='Add Asset']",
      highlightPulse: true,
    },
    {
      id: "assets-name",
      targetSelector: "[role='dialog'] input[name='name']",
      titleKey: "onboarding.tours.assets.name.title",
      descriptionKey: "onboarding.tours.assets.name.description",
      placement: "bottom",
      waitForSelector: "[role='dialog']",
    },
    {
      id: "assets-location",
      targetSelector: "[role='dialog']",
      titleKey: "onboarding.tours.assets.location.title",
      descriptionKey: "onboarding.tours.assets.location.description",
      placement: "right",
    },
    {
      id: "assets-save",
      targetSelector: "[role='dialog'] button[type='submit']",
      titleKey: "onboarding.tours.assets.save.title",
      descriptionKey: "onboarding.tours.assets.save.description",
      placement: "top",
      celebration: "checkmark",
    },
  ],
};
